module.exports = __webpack_public_path__ + "static/p14_oquita-563acb2db17539e32b288171de628965.png";